import React from 'react'

export const Loader = () => {
  return (
    <div className="custom-loader"></div>
  )
}
